import React,{ useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DefaultPaymentSystem } from "./DefaultPaymentSystem";
import { StripePayment } from "./StripePayment";
import { YookassaPayment } from "./YookassaPayment";
import { AmeriabankPayment } from "./AmeriabankPayment";
import { ToastContainer, Flip } from 'react-toastify';
import { onDefaultPaymentLoad } from "../../../store/Settings/actions";
import Loading from "../../../components/Loading";

export const Payments = () => { 
    const [data, setData] = useState({
        paymentProviders: {},
        defaultProvider: "",
        stripeAccounts:[],
        stripeOauthLink: "",
        yookassaAccounts: [],
        yookassaOauthLink: "",
        ameriabankAccount: {}
    }); 
    const dispatch = useDispatch();
    
    useEffect(()=>{
        dispatch(onDefaultPaymentLoad())
    },[])

    const {loading, paymentProviders, defaultProvider, stripeAccounts, stripeOauthLink, 
        yookassaAccounts, yookassaOauthLink, ameriabankAccount} = useSelector(({settings}) => ({
        loading: settings.loading,
        paymentProviders: settings.payments.paymentProviders,
        defaultProvider: settings.payments.defaultProvider,
        stripeAccounts: settings.payments.stripeAccounts,
        stripeOauthLink: settings.payments.stripeOauthLink,
        yookassaAccounts: settings.payments.yookassaAccounts,
        yookassaOauthLink: settings.payments.yookassaOauthLink,
        ameriabankAccount: settings.payments.ameriabankAccount,
    })); 

    useEffect(() => { 
        setData((prevState) => ({
            ...prevState, paymentProviders, defaultProvider, stripeAccounts, 
            stripeOauthLink , yookassaAccounts, yookassaOauthLink, ameriabankAccount}));
        
    }, [paymentProviders, defaultProvider, stripeAccounts, stripeOauthLink, yookassaAccounts, 
        yookassaOauthLink, ameriabankAccount]);
   
    return (
        <Loading loading={loading}>
            <DefaultPaymentSystem 
                paymentProviders={data.paymentProviders}
                defaultProvider={data.defaultProvider}/>
            <StripePayment 
                stripeAccounts={data.stripeAccounts} 
                stripeOauthLink={data.stripeOauthLink}/>
            {/* <YookassaPayment 
                yookassaAccounts={data.yookassaAccounts} 
                yookassaOauthLink={data.yookassaOauthLink}
                redirect={redirect}/> */}
            <AmeriabankPayment ameriabankAccount={data.ameriabankAccount}/>
            <ToastContainer position="top-center" transition={Flip}/>
        </Loading>
    );
};
